<div class="draft-wrap container">
  <div *ngIf="!isLoggedIn" class="login-form row justify-content-center align-items-center" style="min-height: 60vh;">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card p-4 shadow">
        <h2 class="mb-3">Enter your name to join the draft</h2>
        <input [(ngModel)]="username" (keyup.enter)="login()" class="form-control mb-3" placeholder="Your name" maxlength="32" autofocus>
        <button class="btn btn-primary w-100" (click)="login()" [disabled]="!username.trim()">Login</button>
      </div>
    </div>
  </div>
  <div *ngIf="isLoggedIn">
    <div class="row">
      <div class="col">
        <h1>Silver Screen Showdown</h1>
        <p class="text-muted">Welcome, {{ username }}! <span class="badge badge-info">{{ role }}</span></p>
        <span *ngIf="isAdmin" class="badge badge-warning">You are the Admin</span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 col-md-8 mx-auto">
        <div class="card p-3 mb-4">
          <h4>Draft Users</h4>
          <ul class="list-group list-group-flush">
            <li *ngFor="let user of users" class="list-group-item d-flex align-items-center">
              <span class="user-icon mr-2">👤</span> {{ user.username }}
              <span class="ml-auto badge badge-secondary">{{ user.role }}</span>
              <span class="ml-2 badge badge-success">${{ user.wallet }}</span>
              <button *ngIf="isAdmin && user.role !== 'Admin' && user.role !== 'Drafter'" class="btn btn-sm btn-outline-primary ml-3" (click)="setDrafter(user.uuid)">Set Drafter</button>
              <button *ngIf="isAdmin && user.role === 'Drafter' && user.uuid !== users[0].uuid" class="btn btn-sm btn-outline-danger ml-2" (click)="removeDrafter(user.uuid)">Remove Drafter</button>
              <button *ngIf="isAdmin && user.uuid === users[0].uuid && user.role !== 'Drafter'" class="btn btn-sm btn-outline-primary ml-3" (click)="setDrafter(user.uuid)">Set Self Drafter</button>
            </li>
          </ul>
        </div>
        <div *ngIf="isDrafter() && !currentBidItem" class="card p-3 mb-4">
          <h4>New Item to Bid On</h4>
          <div class="input-group mb-2">
            <input [(ngModel)]="newBidItemName" class="form-control" placeholder="Enter item name" maxlength="64">
          </div>
          <div class="input-group mb-2">
            <input [(ngModel)]="bidAmount" type="number" class="form-control" placeholder="Enter your initial bid" [min]="1" [max]="getWallet(loginUuid)">
            <div class="input-group-append">
              <button class="btn btn-success" (click)="addBidItem()" [disabled]="!newBidItemName.trim() || !bidAmount">Add Item</button>
            </div>
          </div>
          <div *ngIf="bidError" class="text-danger mt-1">{{ bidError }}</div>
        </div>
        <div *ngIf="currentBidItem" class="card p-3 mb-4">
          <h4>Current Item Being Bid On</h4>
          <p><strong>{{ currentBidItem.name }}</strong></p>
          <p>Top Bid: ${{ currentBidItem.topBid }} <span *ngIf="currentBidItem.topBidderUuid">by {{ getUsername(currentBidItem.topBidderUuid) }}</span></p>
          <div class="input-group mt-3">
            <input [(ngModel)]="bidAmount" type="number" class="form-control" placeholder="Enter your bid" [min]="currentBidItem.topBid + 1" [max]="getWallet(loginUuid)">
            <div class="input-group-append">
              <button class="btn btn-primary" (click)="placeBid()">Place Bid</button>
            </div>
          </div>
          <div *ngIf="bidError" class="text-danger mt-2">{{ bidError }}</div>
          <button *ngIf="isAdmin" class="btn btn-danger mt-3" (click)="closeBid()">Close Bid</button>
        </div>
        <div class="card p-3">
          <h4>Completed Bid Items</h4>
          <ul class="list-group list-group-flush">
            <li *ngFor="let item of allBidItems" class="list-group-item">
              <strong>{{ item.name }}</strong> - Purchased for ${{ item.purchasedFor }} by {{ getUsername(item.purchasedByUuid) || 'Unknown' }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
